import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import ToursListView from "../views/ToursListView.vue";
import ToursItemView from "../views/ToursItemView.vue";
import HotelListView from "../views/HotelListView.vue";
import HotelItemView from "../views/HotelItemView.vue";
import PackagesListView from "../views/PackagesListView.vue";
import PackagesItemView from "../views/PackagesItemView.vue";
import DayUseListView from "../views/DayUseListView.vue";
import DayUseItemView from "../views/DayUseItemView.vue";
import InstitutionalView from "../views/InstitutionalView.vue";
import ServicesListView from "../views/ServicesListView.vue";
import ServicesItemView from "../views/ServicesItemView.vue";
import AboutCityView from "../views/AboutCityView.vue";
import VideosListView from "../views/VideosListView.vue";

import Error404View from "../views/Error404View.vue";
import PolicyPrivacyView from "../views/PolicyPrivacyView.vue";
import ContactView from "../views/ContactView.vue";
// import ContactResponseView from "../views/ContactResponseView.vue";
// import UnderConstructionView from "../views/UnderConstructionView.vue";

Vue.use(VueRouter);

const routes = [
  {
    name: "Início",
    path: "/",
    component: HomeView,
  },
  {
    name: "Passeios",
    path: "/passeios",
    component: ToursListView,
  },
  {
    name: "Passeio",
    path: "/passeios/:item",
    component: ToursItemView,
  },
  {
    name: "Pousadas",
    path: "/pousadas",
    component: HotelListView,
  },
  {
    name: "Pousada",
    path: "/pousadas/:item",
    component: HotelItemView,
  },
  {
    name: "Pacotes",
    path: "/pacotes",
    component: PackagesListView,
  },
  {
    name: "Pacote",
    path: "/pacotes/:item",
    component: PackagesItemView,
  },
  {
    name: "Day Use",
    path: "/day-use",
    component: DayUseListView,
  },
  {
    name: "Day Use",
    path: "/day-use/:item",
    component: DayUseItemView,
  },
  {
    name: "Institucional",
    path: "/institucional",
    component: InstitutionalView,
  },
  {
    name: "Serviços",
    path: "/servicos",
    component: ServicesListView,
  },
  {
    name: "Serviço",
    path: "/servicos/:item",
    component: ServicesItemView,
  },
  {
    name: "A Cidade",
    path: "/a-cidade",
    component: AboutCityView,
  },
  {
    name: "Vídeos",
    path: "/videos",
    component: VideosListView,
  },
  {
    name: "Contato",
    path: "/contato",
    component: ContactView,
  },
  {
    name: "Política de Privacidade",
    path: "/politica-de-privacidade",
    component: PolicyPrivacyView,
  },
  {
    path: "/erro404",
    name: "Erro 404",
    component: Error404View,
  },
  {
    path: "*",
    name: "Erro 404",
    component: Error404View,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
